<template>
    <div :class="buttonClasses">
        <router-link v-if="link_type === 'page' && routerLink !== ''"
                     class="highlight-button"
                     :class="{light: link_light}"
                     :to="routerLink">
            <span>{{ text }}</span>
        </router-link>
        <a v-else-if="urlLink !== ''"
           class="highlight-button"
           :class="{light: link_light}"
           :href="urlLink"
           :target="target_blank ? '_blank':''"
           @click="scrollToAnchor">
            <span>{{ text }}</span>
        </a>
    </div>
</template>

<script>
    export default {
        name: "HighlightButton",
        props: {
            button_style: {
                type: String,
                default: 'block'
            },
            link_light: {
                type: Boolean,
                default: false,
            },
            link_type: {
                type: String,
                default: 'page'
            },
            text: {
                type: String,
                default: 'Click here'
            },
            url: {
                type: String,
                default: ''
            },
            page: {
                type: String,
                default: ''
            },
            anchor: {
                type: String,
                default: ''
            },
            external_link: {
                type: String,
                default: '',
            },
            target_blank: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            buttonClasses() {
                return `button ${this.button_style}`
            },
            routerLink() {
                return this.url.replace(location.origin, '')
            },
            urlLink() {
                return this.link_type === 'anchor' ? `#${this.anchor}`: this.external_link;
            },
            routerLink() {
                return this.page.replace(location.origin, '')
            }
        },
        methods: {
            scrollToAnchor() {
                if (this.link_type === 'anchor') {
                    this.$scrollTo(`#${this.anchor}`, 500);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

    .highlight-button{
        font-weight: normal;
        background-color: $color1;
        color: #fff;
        padding: 18px 30px;
        text-decoration: none;
        display: block;
        font-size: 17px;
        position: relative;

        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        span{
            position: relative;
            z-index: 1;
        }

        &::before{
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(#000, .4);
            opacity: 0;
            transition: all .3s ease-in-out;
        }

        &:hover::before{
            opacity: 1;
        }

        @media (max-width: 1199px){
            padding: 18px 25px;
            font-size: 15px;
        }

        @media (max-width: 1130px) {
            padding: 18px;
        }

        @media (max-width: 600px){
            padding: 15px 5px;
            text-align: center;
        }

        @media (max-width: 400px){
            font-size: 15px;
        }

        &.light{
            background-color: $color3;
            color: $color1;

            &:hover{
                span{
                    color: #fff;
                }
            }
        }
    }

</style>